import {
  faIdCard,
  faPlusCircle,
  faTrash,
  faEdit,
  faUser,
  faUserFriends,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { AuthWizardContext } from 'context/Context';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Modal, Offcanvas, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from 'stores/modal';
import {
  actionAddIdentification,
  actionLogSigningAction,
  actionMapSignerToAllDocs,
  actionRemoveIdentification,
  actionRemoveSigner,
  actionUpdateIdentification
} from 'stores/signing';
import enums from 'util/enums';
import idGenerator from 'util/idGenerator';
import logger from 'util/logger';
import GenericAddressForm from './comp/GenericAddressForm';
import IdentificationView from './comp/IdentificationView';
import IdentificationForm from './s2/IdentificationForm';
import NotarySignerForm from './s2/NotarySignerForm';
import Flex from 'components/common/Flex';
import classNames from 'classnames';
import draftEntryUiHelper from 'helpers/draft-entry-ui-helper';
import { filter } from 'lodash';
import filters from 'util/filters';
import _ from 'lodash';
import segmentHelper from 'helpers/segment-helper';
import LoadColleague from './LoadColleague';

const Step2 = ({
  register,
  errors,
  setValue,
  saveSigningToDraft,
  setPreviousAddress
}) => {
  const signerInit = {
    isSaving: false,
    isEditMode: false,
    validationErr: [],
    witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
    sorted_witness_ids: null,
    signer_id: null,
    signer_prefix: '',
    signer_first_name: '',
    signer_middle_name: '',
    signer_last_name: '',
    signer_suffix: '',
    signerIdentifications: [],
    witnessIdentifications: [],
    witnessNameLocationResults: [],
    witnessSignatureResults: [],
    GUID: null
  };

  const { user } = useContext(AuthWizardContext);
  const [collapsed, setCollapsed] = useState(false);
  const [isDocumentWitness, setIsDocumentWitness] = useState(false);
  const [isColleagues, setIsColleagues] = useState(false);
  const [showIdentityForm, setShowIdentityForm] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [identityItem, setIdentityItem] = useState();
  const [addressValue, setAddressValue] = useState();
  const [witnessId, setWitnessId] = useState(null);
  const [signerData, setSignerData] = useState(signerInit);
  const [isSaveIdentityToRedux, setSaveIdentityToRedux] = useState(false);
  const [identityForUser, setIdentityForUser] = useState(null);
  const [showColleagueModal, setShowColleagueModal] = useState(false);
  const [isColleaguesWitness, setIsColleaguesWitness] = useState(false);
  const [isManualIDSelected, setIsManualIDSelected] = useState(false);
  const [selectedColleague, setSelectedColleague] = useState({});
  const [selectedIdentification, setSelectedIdentification] = useState({});
  const [signerAddMethod, setSignerAddMethod] = useState(false);
  const [documentWitnessAddMethod, setDocumentWitnessAddMethod] =
    useState(false);
  const [isSignerChanged, setIsSignerChanged] = useState(false);

  const { signers, witnesses, identifications, signatures, location } =
    useSelector(state => state.signing);

  // Feature flag for display master client feature
  const features = useSelector(state => state.authentication.features || []);
  const isMasterClientListEnabled = features.some(
    f => f.Key === 'mastersigning' && f.Value === true
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setPreviousAddress(location);
  }, [location]);

  const removeSigner = signer_id => {
    let foundSigner = _.find(signers, s => s.signer_id === signer_id);
    dispatch(
      actionLogSigningAction(
        `Signer ${filters.formatNameObj(foundSigner)} removed.`
      )
    );
    dispatch(actionRemoveSigner(signer_id));
    setCollapsed(false);
    segmentHelper.track(segmentHelper.events.SIGNING_REMOVE_SIGNER_CLICK);
  };
  const removeSignerIdentificationFromRedux = identification_id => {
    dispatch(actionRemoveIdentification({ identification_id }));
    segmentHelper.track(segmentHelper.events.SIGNING_REMOVED_IDENTIFICATION);
  };
  const openSignerForm = (signer_id, from) => {
    if (signer_id === null) {
      if (from === 'add_colleague') {
        setIsColleagues(true);
        setShowColleagueModal(true);
        setSelectedColleague({});
      } else {
        setCollapsed(true);
      }
      setSignerData(signerData => ({
        ...signerData,
        signer_id: idGenerator.getSignerId(),
        sorted_witness_ids: [],
        isEditMode: false,
        signer_first_name: '',
        signer_middle_name: '',
        signer_last_name: '',
        signer_prefix: '',
        signer_suffix: '',
        witnessChoice: enums.UI_FLOW_TYPE.SIGNER,
        validationErr: [],
        signerIdentifications: [],
        witnessIdentifications: [],
        witnessNameLocationResults: [],
        witnessSignatureResults: []
      }));
    } else {
      let signer = _.find(signers, s => {
        return s.signer_id === signer_id;
      });
      if (signer) {
        setSignerData(_.extend(signerInit, { ...signer, isEditMode: true }));
      }
      setCollapsed(true);
    }
  };

  const openDocumentWithness = (from, data) => {
    setCollapsed(true);
    if (data) {
      setSignerData(
        _.extend(signerInit, {
          ...data,
          isEditMode: true
        })
      );
      if (from == 'edit_document_witness') {
        setIsDocumentWitness(true);
      }
    } else {
      setSignerData(signerData => ({
        ...signerData,
        signer_id: idGenerator.getSignerId(),
        sorted_witness_ids: [],
        isEditMode: false,
        signer_first_name: '',
        signer_middle_name: '',
        signer_last_name: '',
        signer_prefix: '',
        signer_suffix: '',
        witnessChoice: enums.UI_FLOW_TYPE.WITNESS_ONE,
        validationErr: [],
        signerIdentifications: [],
        witnessIdentifications: [],
        witnessNameLocationResults: [],
        witnessSignatureResults: []
      }));

      if (from == 'add_document_witness') {
        setSelectedColleague({});
        setIsDocumentWitness(true);
      } else {
        setIsDocumentWitness(false);
      }
    }
  };

  const resetSignerState = () => {
    setSignerData(signerInit);
    setIdentityItem({});
    setSelectedIdentification({});
    setSelectedColleague({});
    setIsManualIDSelected(false);
    setIsColleagues(false);
    // setCollapsed(!collapsed);
    setIsDocumentWitness(false);
    setAddressValue && setAddressValue();
    setIsColleagues && setIsColleagues(false);
    setIsColleaguesWitness && setIsColleaguesWitness(false);
  };
  //This useEffect will store Identification in localState we will push to Redux on Signer Save
  useEffect(() => {
    if (identityItem?.signer_id) {
      //logger.log('Received Identity', identityItem);
      if (identityItem.witness_id) {
        let witnessIdentificationUpdate = _.concat(
          [],
          signerData.witnessIdentifications || []
        );
        _.remove(
          witnessIdentificationUpdate,
          wid => wid.witness_id === identityItem.witness_id
        );
        witnessIdentificationUpdate.push({
          signer_id: identityForUser,
          witness_id: identityItem.witness_id,
          identification: identityItem
        });
        setSignerData(signerData => ({
          ...signerData,
          witnessIdentifications: witnessIdentificationUpdate
        }));
      } else {
        if (isSaveIdentityToRedux) {
          dispatch(
            actionAddIdentification({
              signer_id: identityForUser,
              identification_id: identityItem.identification_id,
              first_name: identityItem.id_first_name,
              middle_name: identityItem.id_middle_name,
              last_name: identityItem.id_last_name,
              id_first_name: identityItem.id_first_name,
              id_middle_name: identityItem.id_middle_name,
              id_last_name: identityItem.id_last_name,
              prefix: identityItem.id_prefix,
              suffix: identityItem.id_suffix,
              id_type: identityItem.id_type,
              id_type_other: identityItem.id_type_other,
              id_number: identityItem.id_number,
              id_issued_date: identityItem.id_issued_date,
              id_expiration_date: identityItem.id_expiration_date,
              date_of_birth: identityItem.date_of_birth,
              id_issuing_state: identityItem.id_issuing_state,
              id_address_1: identityItem.id_address_1,
              id_address_2: identityItem.id_address_2,
              id_city: identityItem.id_city,
              id_state: identityItem.id_state,
              id_postal_code: identityItem.id_postal_code,
              notes: identityItem.notes,
              scan_vendor: identityItem.scan_vendor,
              scan_data: identityItem.scan_data,
              IsDocumentWitness: isDocumentWitness
            })
          );
          dispatch(actionMapSignerToAllDocs(identityForUser));
        } else {
          let signerIdentificationsUpdate =
            signerData.signerIdentifications || [];
          // Check if identityForUser already exists
          const existingIndex = signerIdentificationsUpdate.findIndex(
            item =>
              item.identification.identification_id ==
              identityItem.identification_id
          );
          if (existingIndex !== -1 && identityItem.identification_id) {
            // If it exists, update the existing entry
            signerIdentificationsUpdate[existingIndex] = {
              ...signerIdentificationsUpdate[existingIndex],
              identification: identityItem,
              IsDocumentWitness: isDocumentWitness
            };
            dispatch(
              actionUpdateIdentification({
                signer_id: signerData.signer_id,
                identification_id: identityItem.identification_id,
                first_name: identityItem.id_first_name,
                middle_name: identityItem.id_middle_name,
                last_name: identityItem.id_last_name,
                id_first_name: identityItem.id_first_name,
                id_middle_name: identityItem.id_middle_name,
                id_last_name: identityItem.id_last_name,
                prefix: identityItem.id_prefix,
                suffix: identityItem.id_suffix,
                id_type: identityItem.id_type,
                id_type_other: identityItem.id_type_other,
                id_number: identityItem.id_number,
                id_issued_date: identityItem.id_issued_date,
                id_expiration_date: identityItem.id_expiration_date,
                date_of_birth: identityItem.date_of_birth,
                id_issuing_state: identityItem.id_issuing_state,
                id_address_1: identityItem.id_address_1,
                id_address_2: identityItem.id_address_2,
                id_city: identityItem.id_city,
                id_state: identityItem.id_state,
                id_postal_code: identityItem.id_postal_code,
                notes: identityItem.notes,
                scan_vendor: identityItem.scan_vendor,
                scan_data: identityItem.scan_data,
                IsDocumentWitness: isDocumentWitness
              })
            );
            dispatch(actionMapSignerToAllDocs(signerData.signer_id));
          } else {
            // If it doesn't exist, add a new entry
            if (identityItem.identification_id) {
              signerIdentificationsUpdate.push({
                signer_id: identityForUser,
                identification: identityItem,
                IsDocumentWitness: isDocumentWitness
              });
            }
          }

          // Update the state
          setSignerData(signerData => ({
            ...signerData,
            signerIdentifications: signerIdentificationsUpdate
          }));
        }
      }
      setShowIdentityForm(false);

      // open document witness form if manual id is selected
      if (isDocumentWitness && isManualIDSelected) {
        setTimeout(() => {
          openDocumentWithness('edit_document_witness', {
            signer_id: identityItem.signer_id,
            identificationFlow: enums.UI_FLOW_TYPE.WITNESS_ONE,
            GUID: selectedColleague.GUID,
            signer_guid: selectedColleague.GUID,
            signer_first_name: selectedColleague.FirstName,
            signer_last_name: selectedColleague.LastName,
            signer_middle_name: selectedColleague.MiddleName,
            signer_prefix: selectedColleague.Prefix,
            signer_suffix: selectedColleague.Suffix,
            first_name: selectedColleague.FirstName,
            last_name: selectedColleague.LastName,
            middle_name: selectedColleague.MiddleName,
            prefix: selectedColleague.Prefix,
            suffix: selectedColleague.Suffix,
            isDocumentWitness: true
          });
        }, 1000);
      }
    }
  }, [identityItem]);

  //This useEffect will store Address in localState we will push to Redux on Signer Save
  useEffect(() => {
    //logger.log('Adding address on state', addressValue);
    if (addressValue) {
      let witnessNameLocationUpdate =
        signerData.witnessNameLocationResults || [];
      if (witnessNameLocationUpdate.length) {
        _.remove(
          witnessNameLocationUpdate,
          wid => wid.witness_id === witnessId
        );
      }
      witnessNameLocationUpdate.push({
        witness_id: witnessId,
        location: addressValue
      });

      setSignerData(signerData => ({
        ...signerData,
        witnessNameLocationResults: witnessNameLocationUpdate
      }));
      setShowAddressForm(false);
    }
    //logger.log('Updated signerdata after location', signerData);
  }, [addressValue]);

  const openSignerIdentityForm = (signer_id, saveToRedux) => {
    setSaveIdentityToRedux(saveToRedux);
    setIdentityForUser(signer_id);
    setSignerData({
      ...signerData,
      signer_id: signer_id
    });
    setWitnessId(null);
    setSelectedIdentification({});
    setShowIdentityForm(true);
    segmentHelper.track(
      segmentHelper.events.SIGNING_ADD_ANOTHER_IDENTIFICATION
    );
  };

  const openWitnessIdentityForm = (signer_id, witness_id) => {
    setIdentityForUser(signer_id);
    setWitnessId(witness_id);
    setShowIdentityForm(true);
    const selectedIdentification = signerData.witnessIdentifications.find(
      item => item.witness_id === witness_id
    );
    setSelectedIdentification(selectedIdentification?.identification);
  };

  const openWitnessAddressForm = witness_id => {
    setWitnessId(witness_id);
    setShowAddressForm(true);
  };

  const openIdentityViewModel = (title, identification) => {
    dispatch(
      showAlert(
        title,
        <div>
          <IdentificationView title={title} identification={identification} />
        </div>,
        res => {
          if (res) {
            //setStartSavingFavourite(startSavingFavourite + 1);
          }
        }
      )
    );
  };

  const AddNewBlock = () => {
    return (
      <div className="text-center">
        {!signers?.length && (
          <>
            <h4>
              <FontAwesomeIcon icon={faUser} />
            </h4>
            <p className="my-3">You haven't added any Signers yet.</p>
          </>
        )}
        <div className="mt-3 mb-3 d-flex justify-content-center flex-column mx-auto">
          <div className="row">
            <div
              className={`${
                isMasterClientListEnabled ? 'col-md-6' : 'col-md-4 offset-md-4'
              }`}
            >
              <Button
                onClick={() => {
                  isMasterClientListEnabled
                    ? setSignerAddMethod(true)
                    : openSignerForm(null, 'add_signer');
                }}
                className="w-100"
                color="primary"
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Add Signer
              </Button>
            </div>
            {isMasterClientListEnabled && (
              <>
                <div className="col-md-6">
                  <Button
                    onClick={() => {
                      setDocumentWitnessAddMethod(true);
                    }}
                    className="ml-2 w-100"
                    color="primary"
                  >
                    <FontAwesomeIcon icon={faIdCard} /> Add Document Witness
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const WitnessRow = ({ signer, witness, index, isLast }) => {
    //logger.log('witness', witness);
    let witnessIdentification = _.find(
      identifications,
      w => w.witness_id === witness.witness_id
    );
    //logger.log('WitnessRow witnessIdentification', witnessIdentification);
    let witnessSignature = witness.signature;
    let witnessLocation = witness.location;
    let witnessDetail = witness.witness_name;
    let witnessName = witness.witnessName?.find(
      item => item.witness_id === witnessIdentification.witness_id
    );
    return witness ? (
      <>
        <hr className="mb-1" />
        <Row
          className={classNames('align-items-center py-2', {
            'border-bottom border-200 ': !isLast
          })}
        >
          <Col className="py-1">
            <Flex className="align-items-center">
              <div className="avatar avatar-sm me-3">
                <div className={`avatar-name rounded-circle bg-soft-priamry`}>
                  <span className={`fs--2`}>
                    {index} ({witness.first_name + ' ' + witness.last_name} )
                  </span>
                </div>
              </div>
              <Flex className="position-relative">
                <Flex tag="h6" align="left" className="mb-0">
                  <Avatar
                    size="m"
                    name={index + 1 + ''}
                    mediaClass={`text-primary bg-soft-primary fs--2 me-2`}
                  />
                  <div className="ms-2 fs-1">
                    <span className="text-primary">Witness </span>{' '}
                    <span className="text-800 stretched-link">
                      {signer?.isDocumentWitness
                        ? `${signer.first_name} ${signer.last_name}`
                        : `${witness.first_name} ${witness.last_name}`}
                    </span>
                    <br />
                    <span className="fs--2 text-primary">
                      {' '}
                      {signer?.isDocumentWitness
                        ? 'Document Witness'
                        : filters.getSignerTypeName(signer.identificationFlow)}
                    </span>
                  </div>
                </Flex>
              </Flex>
            </Flex>
          </Col>
          {/* <Col>
            <Row className="justify-content-end align-items-center">
              <Col xs="auto pe-0">
                <span
                  onClick={() =>
                    openIdentityViewModel(
                      `${witnessDetail.first_name}  ${witnessDetail.last_name}'s Identity`,
                      witnessIdentification
                    )
                  }
                >
                  {witnessIdentification?.length ? (
                    <Button variant="outline-primary" size="sm">
                      {witnessIdentification?.length}
                    </Button>
                  ) : (
                    'N/A'
                  )}
                </span>
              </Col>
            </Row>
          </Col> */}
        </Row>
        <Row>
          {witnessIdentification &&
            draftEntryUiHelper.getIdentificationViewCard(
              witnessIdentification,
              false
            )}

          {witnessSignature &&
            draftEntryUiHelper.getSignatureViewCards(
              'Witness Signature',
              witnessSignature?.data
            )}

          {witnessLocation &&
            (witnessLocation?.address_1 ||
              witnessLocation?.address_2 ||
              witnessLocation?.city ||
              witnessLocation?.state ||
              witnessLocation?.postal_code) &&
            draftEntryUiHelper.getWitnessAddressViewCards(witnessLocation)}
        </Row>
      </>
    ) : (
      <></>
    );
  };

  const SignerRow = ({ data, isLast }) => {
    let identification = _.filter(
      identifications,
      w => w.signer_id === data.signer_id
    );
    let isSigner = data.identificationFlow === enums.UI_FLOW_TYPE.SIGNER;
    let signature = _.filter(
      signatures,
      w => w.signer_id === data.signer_id && !w.witness_id
    );
    let witness = _.filter(witnesses, w => w.signer_id === data.signer_id);
    let witnessName = _.filter(witnesses, w => w.signer_id === data.signer_id);

    //logger.log('SignerRow witness', witness);
    return data && data.first_name ? (
      <Card className="mt-3">
        <div className="p-3">
          <Row
            className={classNames('align-items-center py-2', {
              'border-bottom border-200 ': !isLast
            })}
          >
            <Col className="py-1">
              <Flex className="align-items-center">
                <div className="avatar avatar-xl me-3">
                  <div className={`avatar-name rounded-circle bg-soft-priamry`}>
                    <span className={`fs-0`}>
                      {data.first_name[0] + data.last_name[0]}
                    </span>
                  </div>
                </div>
                <Flex className="position-relative">
                  <Flex tag="h6" align="left" className="mb-0">
                    <div>
                      <span className="text-800 stretched-link">
                        {data.first_name + ' ' + data.last_name}
                      </span>
                      <br />
                      <span className="fs--2 text-primary">
                        {data.isDocumentWitness ? 'Document Witness' : 'Signer'}
                      </span>
                    </div>
                  </Flex>
                </Flex>
              </Flex>
            </Col>
            <Col>
              <Row className="justify-content-end align-items-center">
                <Col xs="auto pe-0">
                  <span
                    onClick={() =>
                      openIdentityViewModel(
                        `${data.first_name}  ${data.last_name}'s Identification`,
                        identification
                      )
                    }
                  >
                    {identification?.length ? (
                      <Button variant="outline-primary" size="sm">
                        {identification?.length} Identification
                      </Button>
                    ) : (
                      'N/A'
                    )}
                  </span>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="outline-primary"
                    className="mx-1"
                    onClick={() => {
                      data.isDocumentWitness
                        ? openDocumentWithness('edit_document_witness', data)
                        : openSignerForm(data.signer_id, 'edit_signer');
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} size="sm" /> Edit
                  </Button>
                  {isSigner && (
                    <Button
                      variant="outline-primary"
                      className="mx-1"
                      onClick={() =>
                        openSignerIdentityForm(data.signer_id, true)
                      }
                    >
                      <FontAwesomeIcon icon={faPlusCircle} size="sm" />{' '}
                      Identification
                    </Button>
                  )}
                  <Button
                    variant="outline-danger"
                    className="mx-1"
                    onClick={() => removeSigner(data.signer_id)}
                  >
                    <FontAwesomeIcon icon={faTrash} size="sm" />{' '}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            {isSigner ? (
              <>
                {identification &&
                  _.map(identification, i => {
                    return draftEntryUiHelper.getIdentificationViewCard(
                      i,
                      identification.length > 1
                        ? removeSignerIdentificationFromRedux
                        : false
                    );
                  })}

                {signature &&
                  _.map(signature, s => {
                    return draftEntryUiHelper.getSignatureViewCards(
                      'Signer Signature',
                      s.imgData.data
                    );
                  })}
              </>
            ) : (
              <>
                {/* {identification &&
                  _.map(identification, i => {
                    return draftEntryUiHelper.getIdentificationViewCard(
                      i,
                      false
                    );
                  })} */}

                {signature &&
                  _.map(signature, s => {
                    return draftEntryUiHelper.getSignatureViewCards(
                      'Signer Signature',
                      s.imgData.data
                    );
                  })}
                {witness &&
                  _.map(witness, (wit, index) => {
                    //logger.log('Prining', wit);
                    return (
                      <WitnessRow
                        key={_.uniqueId('witness-row')}
                        signer={data}
                        witness={wit}
                        index={index}
                        isLast={index === witness.length - 1}
                      />
                    );
                  })}
              </>
            )}
          </Row>
        </div>
      </Card>
    ) : (
      <></>
    );
  };

  return (
    <>
      <div>
        <h5 className="text-center">Add Signers & Witnesses</h5>
        <p className="text-center fs-0">
          Select which method is being used to identify the signer. The most
          common method of identifying the signer is by using the signer's
          approved form of paper identification (i.e. drivers license or
          passport)
        </p>
        <hr className="mb-0" />
        <div>
          <Offcanvas
            id="offcanvas-notarySigner-form"
            show={collapsed}
            backdrop={true}
            onHide={() => {
              setCollapsed(!collapsed);
              setIsDocumentWitness(false);
              resetSignerState();
              setAddressValue && setAddressValue();
              setIsColleagues && setIsColleagues(false);
              setIsColleaguesWitness && setIsColleaguesWitness(false); //Load colleagues
              setIsSignerChanged(false);
            }}
            placement="end"
            className="jurat-wide-offcanvas"
            className="offcanvas-half-width"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                {signerData.isEditMode
                  ? isDocumentWitness
                    ? 'Edit Document Witness Information'
                    : 'Edit Signer Information'
                  : isDocumentWitness
                  ? 'Add Document Witness Information'
                  : 'Add Signer Information'}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <hr className="my-0" />
            <Offcanvas.Body>
              <NotarySignerForm
                setShowIdentityForm={setShowIdentityForm}
                setSelectedIdentification={setSelectedIdentification}
                signers={signers}
                signerData={signerData}
                setSignerData={setSignerData}
                witnesses={witnesses}
                identifications={identifications}
                signatures={signatures}
                setCollapsed={setCollapsed}
                openSignerIdentityForm={openSignerIdentityForm}
                openWitnessAddressForm={openWitnessAddressForm}
                openWitnessIdentityForm={openWitnessIdentityForm}
                resetSignerState={resetSignerState}
                isDocumentWitness={isDocumentWitness}
                setIsDocumentWitness={setIsDocumentWitness}
                isColleagues={isColleagues}
                setIsColleagues={setIsColleagues}
                setIsColleaguesWitness={setIsColleaguesWitness}
                isColleaguesWitness={isColleaguesWitness}
                isFrom="step2"
                witnessId={witnessId}
                collapsed={collapsed}
                isSignerChanged={isSignerChanged}
                setIsSignerChanged={setIsSignerChanged}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        {!collapsed && <AddNewBlock />}
        <hr className="mb-0" />
        {signers && signers.length > 0 && (
          <>
            {/* Signers Card */}
            {signers.some(s => !s.isDocumentWitness) && (
              <Card className="mt-2">
                <FalconCardHeader
                  title={`Signer${
                    signers.filter(s => !s.isDocumentWitness).length > 1
                      ? 's'
                      : ''
                  }`}
                  icon={faUserTie}
                />
                <hr className="my-0" />
                <Card.Body>
                  {signers
                    .filter(s => !s.isDocumentWitness)
                    .map((s, index, arr) => (
                      <SignerRow
                        key={s.signer_id}
                        data={s}
                        isLast={index === arr.length - 1}
                      />
                    ))}
                </Card.Body>
              </Card>
            )}
            <hr className="mb-0" />
            {/* Document Witnesses Card */}
            {signers.some(s => s.isDocumentWitness) && (
              <Card className="mt-2">
                <FalconCardHeader
                  title={`Document Witness${
                    signers.filter(s => s.isDocumentWitness).length > 1
                      ? 'es'
                      : ''
                  }`}
                  icon={faUserFriends}
                />
                <hr className="my-0" />
                <Card.Body>
                  {signers
                    .filter(s => s.isDocumentWitness)
                    .map((s, index, arr) => (
                      <SignerRow
                        key={s.signer_id}
                        data={s}
                        isLast={index === arr.length - 1}
                      />
                    ))}
                </Card.Body>
              </Card>
            )}
          </>
        )}
      </div>

      <Offcanvas
        id="offcanvas-identity-form"
        show={showIdentityForm}
        backdrop="static"
        onHide={() => {
          setShowIdentityForm(false);
          setSelectedIdentification({});
        }}
        placement="end"
        className="jurat-wide-offcanvas"
        className="offcanvas-half-width"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Identification Information</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-0" />
        <Offcanvas.Body>
          <IdentificationForm
            signerData={signerData}
            witnessId={witnessId}
            setIdentityItem={setIdentityItem}
            setShowIdentityForm={setShowIdentityForm}
            isManualIDSelected={isManualIDSelected}
            selectedColleague={selectedColleague}
            setSelectedColleague={setSelectedColleague}
            SelectedIdentification={selectedIdentification}
            setSelectedIdentification={setSelectedIdentification}
            isFrom="step2"
            isSignerChanged={isSignerChanged}
            setIsSignerChanged={setIsSignerChanged}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        id="offcanvas-address-form"
        show={showAddressForm}
        backdrop="static"
        onHide={() => setShowAddressForm(false)}
        placement="end"
        className="jurat-wide-offcanvas"
        className="offcanvas-half-width"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Address form</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-0" />
        <Offcanvas.Body>
          <GenericAddressForm
            addressValue={addressValue}
            setAddressValue={setAddressValue}
            setShowAddressForm={setShowAddressForm}
            register={register}
            errors={errors}
            col={12}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <LoadColleague
        showColleagueModal={showColleagueModal}
        setShowColleagueModal={setShowColleagueModal}
        setSignerData={setSignerData}
        signerData={signerData}
        setShowIdentityForm={setShowIdentityForm}
        showIdentityForm={showIdentityForm}
        setCollapsed={setCollapsed}
        identityItem={identityItem}
        setIsColleagues={setIsColleagues}
        setIsColleaguesWitness={setIsColleaguesWitness}
        isManualIDSelected={isManualIDSelected}
        setIsManualIDSelected={setIsManualIDSelected}
        selectedColleague={selectedColleague}
        setSelectedColleague={setSelectedColleague}
        resetSignerState={resetSignerState}
        isDocumentWitness={isDocumentWitness}
        setIsDocumentWitness={setIsDocumentWitness}
        setAddressValue={setAddressValue}
        isFrom="step2"
        openDocumentWithness={openDocumentWithness}
      />
      <Modal
        show={signerAddMethod}
        onHide={() => setSignerAddMethod(!signerAddMethod)}
        className="full-screen-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{'Choose Signer Method'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You can add a signer either by selecting from the existing client
            list or creating a new one.
          </p>
          <div className="row justify-content-center align-items-center mb-2">
            <div className="col-md-6">
              <Button
                onClick={() => {
                  setSignerAddMethod(!signerAddMethod);
                  openSignerForm(null, 'add_colleague');
                }}
                className="w-100"
                color="primary"
              >
                <FontAwesomeIcon icon={faUserFriends} /> Add an existing client
                as a signer
              </Button>
            </div>
            <div className="col-md-6">
              <Button
                onClick={() => {
                  setSignerAddMethod(!signerAddMethod);
                  openSignerForm(null, 'add_signer');
                }}
                className="w-100"
                color="primary"
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Add new signer
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={documentWitnessAddMethod}
        onHide={() => setDocumentWitnessAddMethod(!documentWitnessAddMethod)}
        className="full-screen-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{'Choose Document Witness Method'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You can add a document witness either by selecting from the existing
            client list or creating a new one.
          </p>
          <div className="row justify-content-center align-items-center mb-2">
            <div className="col-md-7">
              <Button
                onClick={() => {
                  setDocumentWitnessAddMethod(!documentWitnessAddMethod);
                  setIsDocumentWitness(true);
                  openSignerForm(null, 'add_colleague');
                }}
                className="w-100"
                color="primary"
              >
                <FontAwesomeIcon icon={faUserFriends} /> Add an existing client
                as a document witness
              </Button>
            </div>
            <div className="col-md-5">
              <Button
                onClick={() => {
                  setDocumentWitnessAddMethod(!documentWitnessAddMethod);
                  openDocumentWithness('add_document_witness', null);
                }}
                className="w-100"
                color="primary"
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Add new document witness
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

Step2.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired
};

export default Step2;
